export enum TargetNames {
  'Patient' = 0,
  'Payer' = 1,
  'Physician' = 2,
  'Pharmacy' = 3,
}
